import { useAuth } from "@/App";

const ROLE_PERMISSIONS = {
  admin: {
    vehicles: ["create", "read", "update", "delete", "read_prices", "read_margin"],
    preparation: ["create", "read", "update", "delete"],
    documents: ["create", "read", "update", "delete"],
    photos: ["create", "read", "update", "delete"],
    clients: ["create", "read", "update", "delete"],
    invoices: ["create", "read", "update", "delete", "read_purchase"],
    fournisseurs: ["create", "read", "update", "delete"],
    purchase_invoices: ["create", "read", "update", "delete"],
    depot_vente: ["create", "read", "update", "delete"],
    audits: ["create", "read", "update", "delete"],
    users: ["create", "read", "update", "delete"],
    settings: ["read", "update"],
    logs: ["read"],
    dashboard: ["read", "read_financial"],
    annonces: ["create", "read", "update", "delete"],
    emails: ["send", "read"],
    rapports: ["read"]
  },
  commercial: {
    vehicles: ["create", "read", "update", "read_prices"],
    preparation: ["read"],
    documents: ["create", "read", "update"],
    photos: ["create", "read", "update"],
    clients: ["create", "read", "update", "delete"],
    invoices: ["read"],
    fournisseurs: ["read"],
    purchase_invoices: ["read"],
    depot_vente: ["read"],
    audits: ["read"],
    users: [],
    settings: [],
    logs: [],
    dashboard: ["read"],
    annonces: ["create", "read", "update", "delete"],
    emails: ["send", "read"],
    rapports: []
  },
  preparateur: {
    vehicles: ["read"],
    preparation: ["create", "read", "update"],
    documents: ["read"],
    photos: ["create", "read", "update", "delete"],
    clients: [],
    invoices: [],
    audits: ["create", "read"],
    users: [],
    settings: [],
    logs: [],
    dashboard: ["read"],
    annonces: ["read"],
    emails: [],
    rapports: []
  },
  auditeur: {
    vehicles: ["read"],
    preparation: ["read"],
    documents: ["read"],
    photos: ["read"],
    clients: [],
    invoices: [],
    audits: ["create", "read", "update"],
    users: [],
    settings: [],
    logs: [],
    dashboard: ["read"],
    annonces: [],
    emails: [],
    rapports: []
  },
  comptabilite: {
    vehicles: ["read", "read_prices", "read_margin"],
    preparation: ["read"],
    documents: ["read"],
    photos: ["read"],
    clients: ["read"],
    invoices: ["create", "read", "update", "delete", "read_purchase"],
    fournisseurs: ["read"],
    purchase_invoices: ["create", "read", "update", "delete"],
    audits: ["read"],
    users: [],
    settings: ["read"],
    logs: ["read"],
    dashboard: ["read", "read_financial"],
    annonces: [],
    emails: ["read"],
    rapports: ["read"]
  }
};

export function usePermissions() {
  const { user } = useAuth();

  const can = (module, action) => {
    if (!user) return false;
    // Check custom user permissions first
    if (user.permissions && Object.keys(user.permissions).length > 0 && module in user.permissions) {
      return user.permissions[module]?.includes(action) || false;
    }
    // Fallback to role defaults
    const rolePerms = ROLE_PERMISSIONS[user.role];
    if (!rolePerms) return false;
    return rolePerms[module]?.includes(action) || false;
  };

  return { can, user };
}
